export * from './ui-filter-group';
export * from './ui-paginated-filter-item';
export * from './ui-date-preset-filter-item';
export * from './ui-date-range-filter-item';
export * from './ui-multi-filter-item';
export * from './ui-period-filter-item';

export enum DateFilterEnum {
    Today = '1d',
    Last7Days = '7d',
    Last4Weeks = '4w',
    Last3Months = '3m',
    Last6Months = '6m',
    Last12Months = '12m',
    MonthToDate = 'm',
    YearToDate = 'y',
    Custom = 'custom',
    AllTime = 'all'
}

export enum PeriodFilterEnum {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly'
}

export type DateFilterPreset = {
    type: DateFilterEnum;
    from: Date;
    to: Date;
};
